"use client";

import React, { useState, useRef } from "react";
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";

const testimonials = [
  { name: "A. Student", title: "Secured MBBS in State College", subtitle: "Rank 12,345", text: "Great guidance and timely updates helped me secure my seat." },
  { name: "B. Student", title: "Got MBBS in Dream College", subtitle: "Rank 23,456", text: "The tools were accurate and the mentors were supportive." },
  { name: "C. Student", title: "Counselling Success", subtitle: "Rank 34,567", text: "I felt assured at every step thanks to the team." },
];

export default function TestimonialCarousel() {
  const [activeIdx, setActiveIdx] = useState(0);
  const scrollContainerRef = useRef(null);

  const handlePrev = () => setActiveIdx((i) => (i - 1 + testimonials.length) % testimonials.length);
  const handleNext = () => setActiveIdx((i) => (i + 1) % testimonials.length);

  return (
    <section className="w-full mx-auto px-4 py-8">
      <div className="text-center mb-6">
        <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-2">NEET UG Aspirants Share <span className="text-[#ff9245]">Their Experience</span></h2>
        <p className="text-gray-600">See how NEET UG aspirants gained clarity and confidence through counselling support.</p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow p-6">
          <div className="text-gray-800 text-lg mb-4">
            <RiDoubleQuotesR className="inline w-6 h-6 text-[#ff9245] mr-2" />
            {testimonials[activeIdx].text}
          </div>
          <div className="text-sm font-bold">{testimonials[activeIdx].name}</div>
          <div className="text-xs text-gray-500 mb-2">{testimonials[activeIdx].title} — {testimonials[activeIdx].subtitle}</div>

          <div className="flex items-center justify-center gap-4 mt-4">
            <button onClick={handlePrev} className="p-2 rounded-full bg-gray-100">Prev</button>
            <button onClick={handleNext} className="p-2 rounded-full bg-gray-100">Next</button>
          </div>
        </div>
      </div>
    </section>
  );
}
